import { memo, VFC } from "react";

export const Page404: VFC = memo(() => {
    return (
        <>
            <p>404ページです</p>
        </>
    )
})